<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
            <p class="ts-text-gray-500">
              <b
                ><i
                  ><span class="text-danger">* </span
                  >{{ $t('scheduletime.note') }}:
                </i></b
              >
              {{ $t('scheduletime.onlyuseratheadofficecanmodifyordelete') }}
            </p>
          </div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('scheduletime.searchonlysubprogram')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'acps_name'
        }"
      >
        <template v-slot="{ record }">
          <td>
            {{ record.sc_from_time }}
          </td>
          <td>{{ record.sc_to_time }}</td>
          <td>{{ record.st_time_id ? record.st_time_id + ' hours' : '' }}</td>
          <td>{{ record.shift_name }}</td>
          <td>{{ record.payable_minute }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'schedule-time-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('scheduletime.fromTime') },
        { name: this.$t('scheduletime.toTime') },
        { name: this.$t('scheduletime.timestudyday'), style: 'width:15%' },
        { name: this.$t('scheduletime.shift'), style: 'width:25%' },
        { name: this.$t('scheduletime.payableMinute'), style: 'width:25%' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('scheduleTime', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.scheduleTime.search
      },
      set(newValue) {
        this.$store.commit('scheduleTime/SET_SEARCH', newValue)
        this.$store.commit('scheduleTime/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('scheduleTime/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('scheduleTime/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'schedule-time-edit',
        params: { id: record.sc_time_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('scheduleTime/destroy', record.sc_time_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function() {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
